/**
 * User name + compact role badge.
 * layout="inline" (default): name and badge side-by-side
 * layout="stacked": badge under the name (table cells)
 */

import React from 'react';
import { formatRoleName } from '../../../utils/roleFormatter';
import './TransferActor.css';

const TransferActor = ({ name, role, fallback = '—', className = '', layout = 'inline' }) => {
  if (!name && !role) {
    return <span className={`transfer-actor-empty ${className}`.trim()}>{fallback}</span>;
  }

  const isStacked = layout === 'stacked';

  return (
    <span
      className={`transfer-actor ${isStacked ? 'transfer-actor-stacked' : 'transfer-actor-inline'} ${className}`.trim()}
    >
      <span className="transfer-actor-name">{name || 'Unknown'}</span>
      {role && (
        <span className="transfer-actor-role-badge">{formatRoleName(role)}</span>
      )}
    </span>
  );
};

export default TransferActor;
